import { IncomingHttpHeaders } from 'http'
import { parseBase64 } from './parseBase64'
import { IUser } from '../interfaces/common'

export function parseUser(headers: IncomingHttpHeaders = {}): IUser | null {
  const userProps = headers['x-user-properties'] as string
  const isAuthenticated = headers['x-user-authenticated'] === '1'
  const userId = headers['x-user-id'] as string

  let user = null

  if (isAuthenticated && userId) {
    user = userProps ? parseBase64<IUser>(userProps) : null
    user = { ...user, id: userId, isAuthenticated }
  }

  return user
}
